export enum TransactionStatus {
  Unknown = 'Unknown',
  Scheduled = 'Scheduled',
  Success = 'Success',
  Fail = 'Fail',
  Canceled = 'Canceled',
  AwaitingApproval = 'AwaitingApproval',
}
